import { runtimeEnv } from "./runtime-config";
/**
 * synapsedx.console.enabled flag (`VITE_SYNAPSEDX_CONSOLE`, SYN-1953).
 *
 * Gates the /synapsedx/catalog console surface and its nav entry. Mirrors the
 * community-grab gating model: a boolean baked into the SPA at build time.
 * Unset/blank/anything other than a recognised truthy literal = OFF (fail
 * closed). Truthy literals: "1", "true", "on", "yes" (case-insensitive).
 *
 * Nav + route gating is presentation only. The BFF enforces the REAL authority
 * check (isPlatformAdmin from the server grant) and returns 403 for any caller
 * who is not a genuine super-admin — including Clerk-flag-true/grant-false users.
 */

const TRUTHY = new Set(["1", "true", "on", "yes"]);

/**
 * Pure derivation: the flag is ON iff the raw value is a recognised truthy
 * literal. Anything else (undefined, "", "0", "false", noise) is OFF.
 */
export function deriveSynapsedxConsole(raw: string | null | undefined): boolean {
  if (typeof raw !== "string") {
    return false;
  }
  return TRUTHY.has(raw.trim().toLowerCase());
}

/** Read VITE_SYNAPSEDX_CONSOLE from Vite env and derive the flag. */
export function isSynapsedxConsoleEnabled(): boolean {
  return deriveSynapsedxConsole(runtimeEnv("VITE_SYNAPSEDX_CONSOLE") as unknown as string);
}
